export const truncate = (str: string, maxLen: number): string => {
  if (str.length <= maxLen) return str;
  return str.slice(0, maxLen) + '...';
};

export const formatTimestamp = (ts: string | number): string => {
  const date = typeof ts === 'number' ? new Date(ts) : new Date(ts);
  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  });
};

export const LOG_LEVEL_COLORS: Record<string, { bg: string; badge: string; text: string }> = {
  error: { bg: 'bg-red-50', badge: 'bg-red-100 text-red-800', text: 'text-red-700' },
  warn: { bg: 'bg-yellow-50', badge: 'bg-yellow-100 text-yellow-800', text: 'text-yellow-700' },
  info: { bg: 'bg-white', badge: 'bg-blue-100 text-blue-800', text: 'text-neutral-900' },
  debug: { bg: 'bg-white', badge: 'bg-neutral-100 text-neutral-600', text: 'text-neutral-600' },
};
